export default __webpack_public_path__ + "static/toggle-6c37b14733dc60d8be7f21542eba21d6.png";